// src/autodesk_usage/components/corporate/CompanyMonthlyUsageChart.tsx
// All comments in English only
import ActiveLicenseUsageChart, {
  type UsageMode,
} from "./ActiveLicenseUsageChart";

interface Props {
  companyName: string | string[];
  mode: UsageMode;
  startMonth: string;
  endMonth: string;
}

export default function CompanyMonthlyUsageChart({
  companyName,
  mode,
  startMonth,
  endMonth,
}: Props) {
  return (
    <ActiveLicenseUsageChart
      scope="company"
      entityName={companyName}
      title="Company Active licenses"
      mode={mode}
      startMonth={startMonth}
      endMonth={endMonth}
    />
  );
}
